module.exports = __webpack_public_path__ + "static/media/fail.78efdbfd.svg";